import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { NotFoundComponent } from './pages/not-found/not-found.component'
import { FaqComponent } from './pages/faq/faq.component'
import { HomeComponent } from './pages/home/home.component'
import { MissionComponent } from './pages/mission/mission.component'
import { DifferentialComponent } from './pages/differential/differential.component'
import { ProductsComponent } from './pages/products/products.component'
import { PressRoomComponent } from './pages/press-room/press-room.component'
import { CertificationsComponent } from './pages/certifications/certifications.component'
import { EconomyTableComponent } from './pages/economy-table/economy-table.component'
import { DownloadsComponent } from './pages/downloads/downloads.component'
import { WhereToFindComponent } from './pages/where-to-find/where-to-find.component'
import { WhereToFindComponentOld } from './pages/where-to-find-old/where-to-find-old.component'
import { HistoryComponent } from './pages/history/history.component'
import { ContactComponent } from './pages/contact/contact.component'
import { RevendedorComponent } from './pages/revendedor/revendedor.component'
import { ElementoFiltranteComponent } from './pages/elemento-filtrante/elemento-filtrante.component'
import { InternaProdutoComponent } from './pages/interna-produto/interna-produto.component'
import { SustentabilidadeComponent } from './pages/sustentabilidade/sustentabilidade.component'
import { SeloABRAFIPAComponent } from './pages/selo-abrafipa/selo-abrafipa.component'
import { ExportationComponent } from './pages/exportation/exportation.component'
import { RevendaComponent } from './pages/revenda/revenda.component'
import { IceMachineComponent } from './pages/ice-machine/ice-machine.component'
import { CertificationsIceMachineComponent } from './pages/certifications-ice-machine/certifications-ice-machine.component'
import { PantanalComponent } from './pages/pantanal/pantanal.component';
import { BottleNivaComponent } from './pages/bottle-niva/bottle-niva.component'
import { B2bComponent } from './pages/b2b/b2b.component'
import { EverestPlusComponent } from './pages/everest-plus/everest-plus.component'
import { RelatorioGtmComponent } from './pages/relatorio-gtm/relatorio-gtm.component'
import { RelatorioGtmLoginComponent } from './pages/relatorio-gtm-login/relatorio-gtm-login.component'
import { GtmReportAuthGuard } from './guard/gtm-report-auth.guard'

const routes: Routes = [
    {
        path: '',
        redirectTo: '/pt/home',
        pathMatch: 'full',
    },
    {
        path: '404',
        component: NotFoundComponent,
        data: { title: 'Página não encontrada' },
    },
    {
        path: ':lang',
        children: [
            {
                path: 'home',
                component: HomeComponent,
                data: {
                    title: 'Home',
                },
            },
            {
                path: 'perguntas-frequentes',
                component: FaqComponent,
                data: {
                    title: 'Perguntas frequentes',
                },
            },
            {
                path: 'missao',
                component: MissionComponent,
                data: {
                    title: 'Missão, Visão e Valores',
                },
            },
            {
                path: 'diferencial',
                component: DifferentialComponent,
                data: {
                    title: 'Diferencial',
                },
            },
            {
                path: 'diferencial/:differential',
                component: DifferentialComponent,
                data: {
                    title: 'Diferencial',
                },
            },
            {
                path: 'purificadores',
                component: ProductsComponent,
                data: {
                    title: 'Purificadores',
                },
            },
            {
                path: 'certificacoes',
                component: CertificationsComponent,
                data: {
                    title: 'Certificações',
                },
            },
            {
                path: 'certificacoes-maquinas-de-gelo',
                component: CertificationsIceMachineComponent,
                data: {
                    title: 'Certificações',
                },
            },
            {
                path: 'economia',
                component: EconomyTableComponent,
                data: {
                    title: 'Tabela de Economia',
                },
            },
            {
                path: 'manuais',
                component: DownloadsComponent,
                data: {
                    title: 'Manuais',
                    cmsSlug: 'downloads',
                },
            },
            {
                path: 'manuais-garrafas',
                component: DownloadsComponent,
                data: {
                    title: 'Manuais Garrafas',
                    cmsSlug: 'manual-garrafas',
                },
            },
            {
                path: 'manual-maquinas-de-gelo',
                component: DownloadsComponent,
                data: {
                    title: 'Manual máquinas de gelo',
                    cmsSlug: 'manual-maquinas-de-gelo',
                },
            },
            {
                path: 'onde-encontrar-assistencia-everest',
                component: WhereToFindComponent,
                data: {
                    title: 'Onde encontrar assistência',
                },
            },
            {
                path: 'onde-encontrar',
                component: WhereToFindComponent,
                data: {
                    title: 'Onde encontrar',
                },
            },
            {
                path: 'onde-encontrar-revenda-everest',
                component: WhereToFindComponent,
                data: {
                    title: 'Onde encontrar',
                },
            },
            {
                path: 'historia',
                component: HistoryComponent,
                data: {
                    title: 'Historia',
                },
            },
            {
                path: 'atendimento',
                component: ContactComponent,
                data: {
                    title: 'Atendimento',
                },
            },
            {
                path: 'seja-revendedor',
                component: RevendedorComponent,
                data: {
                    title: 'Seja um revendedor',
                },
            },
            {
                path: 'refil-original-everest',
                component: ElementoFiltranteComponent,
                data: {
                    title: 'Refil Original',
                },
            },
            {
                path: 'produto/garrafa-niva',
                component: BottleNivaComponent,
                data: {
                    title: 'Garrafa Niva',
                },
            },
            {
                path: 'para-empresas',
                component: B2bComponent,
                data: {
                    title: 'B2B',
                },
            },
             {
                path: 'purificador/:slug',
                component: EverestPlusComponent,
                data: {
                    title: 'Inverter Plus',
                },
            },
            {
                path: 'produto/:slug',
                component: IceMachineComponent,
                data: {
                    title: 'Máquinas de Gelo',
                },
            },
            {
                path: 'produtos/:slug',
                component: InternaProdutoComponent,
                data: {
                    title: 'Produto',
                },
            },
            {
                path: 'exportacao',
                component: ExportationComponent,
                data: {
                    title: 'Produto',
                },
            },
            {
                path: 'sustentabilidade',
                component: SustentabilidadeComponent,
                data: {
                    title: 'Sustentabilidade',
                },
            },
            {
                path: 'sos-pantanal',
                component: PantanalComponent,
                data: {
                    title: 'SOS Pantanal',
                },
            },
            {
                path: 'sala-de-imprensa',
                component: PressRoomComponent,
                data: {
                    title: 'Sala de Imprensa',
                },
            },
            {
                path: 'selo-ABRAFIPA',
                component: SeloABRAFIPAComponent,
                data: {
                    title: 'Selo ABRAFIPA',
                },
            },
            {
                path: 'maquinas-de-gelo',
                component: ProductsComponent,
                data: {
                    title: 'Maquinas de Gelo',
                },
            },
            {
                path: 'relatorio-gtm-login',
                component: RelatorioGtmLoginComponent,
                data: {
                    title: 'Login - Painel de medição',
                },
            },
            {
                path: 'relatorio-gtm',
                component: RelatorioGtmComponent,
                canActivate: [GtmReportAuthGuard],
                data: {
                    title: 'Painel de medição',
                },
            },
            {
                path: '404',
                component: NotFoundComponent,
                data: { title: 'Página não encontrada' },
            },
            {
                path: '**',
                redirectTo: '404',
                pathMatch: 'full',
                data: { title: 'Página não encontrada' },
            },
        ],
    },
]

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
